import { http } from '@talend/http';

export function getVersions() {
	return http.get('/api/versions');
}
